import React, { ReactChild } from 'react';
import { Container } from './MenuOpenButton.styles';

type Props = {
  children: ReactChild;
};

const MenuOpenButton = (props: Props) => <Container>{props.children}</Container>;
export default MenuOpenButton;
